
@if (chatService.toggle) {
  <div  class="toggler text-center" [ngClass]="{'increase': chatService.toggle, 'decrease': !chatService.toggle}">
    <div class="chat-menu container-fluid" [ngClass]="{'fadeOut': !chatService.toggle, 'fadeIn': chatService.toggle, 'block': !toggleDisplay}">
      <div class="top text-center" style="display: flex; justify-content: space-between;">
        <h4 style="margin-left: 33% ;">Assessor Chatbot</h4>
        <div (click)='chatService.openChatBot(); toggleDisplay = false;  ' class="exit float-end">
          <i class="fas fa-times"></i>
        </div>
      </div>
      <div id="chat" class="chat">
        <div id="chatBoxWrapper" class="chat__wrapper">
          <!-- <div (click)="addMessageManual('Proposition 19')" class="chat__message curser  clearfix" [ngClass]="{'chat__message-own': true}">
          <div class="inner-text">{{'ChatBot.Prop19' | translate}}</div>
        </div>
        <div (click)="addMessageManual('Homeowners Exemptions')" class="chat__message curser  clearfix" [ngClass]="{'chat__message-own': true}">
          <div class="inner-text">{{'ChatBot.Homeowners' | translate}}</div>
        </div>
        <div (click)="addMessageManual('New Construction')" class="chat__message curser  clearfix" [ngClass]="{'chat__message-own': true}">
          <div class="inner-text">{{'ChatBot.Construction' | translate}}</div>
        </div> -->
        @for (item of messages; track item) {
          <div class="chat__message clearfix" [ngClass]="{'chat__message-own': !item.isUser}">
            @if (item.isUser) {
              <img src="../../../assets/imgs/seal.png" alt="Avatar">
            }
            <div class="inner-text" id="{{item.id}}" [innerHTML]="item.message"></div>
          </div>
        }
        @if (toggleSpinner) {
          <div style="width: 100%" class="chat__message  clear-fix">
            <img src="../../../assets/imgs/seal.png" alt="Avatar" class="">
            <div style="width: 100%; position: relative; height: 100px" class="inner-text">
              <ngx-spinner [fullScreen]="false" color="#fff" bdColor="#e6e7ec"
                type="ball-spin-fade-rotating" size="medium">
              </ngx-spinner>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="chat__form">
      <form autocomplete="off" #chatForm="ngForm" (ngSubmit)="addMessage(chatForm); chatForm.resetForm()" id="chat__form">
        <input autocomplete="off" id="text-message" [(ngModel)]="setMessage" name="msg" type="text" placeholder="Type your message here ...">
        <button type="submit">Send</button>
      </form>
    </div>
    <div id="result"></div>
  </div>
</div>
}
